<template>
  <ol class="breadcrumb my-auto">
    <!--    <li class="breadcrumb-item my-auto pointer-click" data-bs-toggle="offcanvas"-->
    <!--        data-bs-target="#offcanvasTopGroupSelectionThemes" v-if="firstLevelTheme">{{-->
    <!--        datahelper.theme_list.find(theme => theme.id === firstLevelTheme).label-->
    <!--      }}-->
    <!--      <icon :icon="['far', 'caret-down']" class="fa-1x my-auto"/>-->
    <!--    </li>-->
    <!--    <li class="breadcrumb-item my-auto pointer-click" data-bs-toggle="offcanvas"-->
    <!--        data-bs-target="#offcanvasTopGroupSelectionThemes" v-if="secondLevelTheme">-->
    <!--      {{ datahelper.theme_list.find(theme => theme.id === secondLevelTheme).label }}-->
    <!--      <icon :icon="['far', 'caret-down']" class="fa-1x my-auto"/>-->
    <!--    </li>-->
    <li class="breadcrumb-item my-auto active pointer-click" aria-current="page"
        v-on:click="showSessionSelector = true;"
        v-if="!showSessionSelector">
      {{ sessionlist[selectedSessionComp]['title'] }}
      <icon :icon="['far', 'caret-down']" class="fa-1x my-auto"/>
    </li>
    <li class="breadcrumb-item my-auto active d-flex" aria-current="page" v-if="showSessionSelector">
      <div class="input-group">
        <select class="form-select form-select-sm my-auto" aria-label="Theme select"
                v-model="selectedSessionComp">
          <option :value="sessionItem.id"
                  v-on:click="selectOption"
                  v-for="sessionItem in sessionlist">
            {{ sessionItem.title }}
          </option>
        </select>
        <button class="btn btn-sm btn-primary" type="button" v-on:click="showSessionSelector = false;">
          <icon :icon="['fal', 'x']" class="fa-1x my-auto"/>
        </button>
      </div>
    </li>
  </ol>
</template>
<script>
import {mapGetters, mapMutations, mapState} from "vuex";

export default {
  name: 'BreadcrumbSession',
  data: function () {
    return {
      showSessionSelector: false
    }
  },
  computed: {
    ...mapState([
      'posters', 'mode', 'fullscreen', 'loader', 'themes', 'datahelper', 'ratings'
    ]),
    ...mapState('session', ['selectedSession', 'sessionlist']),
    selectedSessionComp: {
      get() {
        return this.selectedSession
      },
      set(id) {
        this.setSelectedSession(id);
      }
    }
  },
  methods: {
    ...mapMutations('session', ['setSelectedSession']),
    selectOption() {
      this.showSessionSelector = false;
    }
  },
}
</script>
